export default __webpack_public_path__ + "636da39d335b9d00f0b57363efd9c368.svg";